import template from './ko-field-input-date.html';

class DateInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.help_text = ko.observable(params.help_text);
		this.time = ko.observable(params.time);
	}
}


export default {
	name: 'ko-field-input-date',
	viewModel: DateInputComponentVM,
	module_type: 'ko',
	template: template
}
